import { useIntl } from 'react-intl';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { Social } from '@/components/signup/account-creation/components/social/social';
import { JiraOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';

import { GetStartedText } from '../../../components/get-started-heading';
import { Headings } from '../../../components/headings';
import { InputSubmitButton } from '../../../components/submit-input';

export const LoggedOutJiraStandard = () => {
	const intl = useIntl();

	const heading2 = intl.formatMessage({
		id: 'BxpUiSignup.SignupForm.subheader.jsw.standard',
		defaultMessage:
			'14-day free trial for unlimited users on the Standard plan — no credit card needed',
	});

	return (
		<JiraOverlayTemplate size="sm">
			<main>
				<Headings main={<GetStartedText productName="Jira" />} sub={heading2} />
				<AccountCreation Input={<InputSubmitButton />} Social={<Social />} Submit={null} />
			</main>
		</JiraOverlayTemplate>
	);
};
